<template>
  <table class="total-table elevation-1">
    <tr>
      <th>{{$t('headers.image')}}</th>
      <th>{{$t('headers.category')}}</th>
      <th>{{$t('headers.partName')}}</th>
      <th>{{$t('headers.serialNumber')}}</th>
      <th>{{$t('headers.serviceTag')}}</th>
    </tr>
    <tr
    v-for="({imageUrl, category, partName, serialNumber, serviceTag}, i) in items"
    :key="i"
    :class="`row--${i % 2 === 0 ? 'even' : 'odd'}`">
      <td>
        <img :src="imageUrl" style="object-fit: contain;" width="60px" />
      </td>
      <td>{{category}}</td>
      <td>{{partName}}</td>
      <td>{{serialNumber}}</td>
      <td>{{serviceTag}}</td>
    </tr>
  </table>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
table.total-table {
  max-width: 37rem;
}
table.total-table, tr, td, th {
  padding: 5px 10px;
  text-align: start;
  border: 1px solid rgb(255, 255, 255);
  border-collapse: collapse;
}

.total-table > tr > th {
  padding: 5px 10px;
  background-color: #CFD8DC;
  min-width: 10rem;
}
.total-table > tr.row--even {
  background-color: #F6F6F6;
}
.total-table > tr.row--odd {
  background-color: #F1F1F1;
}
</style>